import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import dayjs from 'dayjs';
import { BluecoinData, BluecoinsData } from './types';
import './bluecoinPanel.scss';
import {
  bluecoinsAtom,
  isBluecoinListPanelOpenAtom,
  isBluecoinPanelOpenAtom,
} from './BluecoinState';
import useAnalytics from '../../../hooks/useAnalytics';
// eslint-disable-next-line import/order
import React from 'react';

export function BluecoinPanel(): React.JSX.Element | null {
  const { formatMessage: f } = useIntl();
  const bluecoinsData = useRecoilValue<BluecoinsData>(bluecoinsAtom);
  const [isBluecoinSelected, setIsBluecoinSelected] = React.useState<number | false>(false);
  const [isBluecoinsPanelOpen, setIsBluecoinPanelOpen] = useRecoilState<number | false>(
    isBluecoinPanelOpenAtom
  );
  const [isBluecoinListPanelOpen, setIsBluecoinListPanelOpen] = useRecoilState<number[] | false>(
    isBluecoinListPanelOpenAtom
  );
  const { trackEvent } = useAnalytics();

  const handleCloseBluecoinPanel = (): void => {
    trackEvent(['map', 'click', 'Close bluecoin panel']);
    setIsBluecoinSelected(false);
    setIsBluecoinPanelOpen(false);
    setIsBluecoinListPanelOpen(false);
  };

  const handleDateFormat = (date: string | null): string => {
    if (date) {
      return dayjs(date).format('DD.MM.YYYY HH:mm');
    }
    return '';
  };

  const handleBackToBluecoinList = (): void => {
    trackEvent(['map', 'click', 'Back to bluecoins list on the same position']);
    setIsBluecoinPanelOpen(false);
  };

  const bluecoinData: BluecoinData = bluecoinsData[Number(isBluecoinsPanelOpen)];

  return (
    <div className="w-map w-map--wrapper" data-cy="bluecoin-panel">
      <div className="w-map">
        <div className="b-widgets-info">
          <div className="b-tabs-toggler">
            <ul>
              <li className="active" key="bluecoin-list">
                <button
                  id="bluecoin-tab"
                  type="button"
                  data-cy="bluecoin-tab"
                  style={{ width: 'auto' }}
                  title={f({ id: 'table_list.tabs.bluecoin.list' })}
                >
                  {f({ id: 'bluecoins.bluecoinPanel.detail' })}
                </button>
              </li>

              <li className="tab-actions" />

              <li className="tab-actions">
                <button
                  type="button"
                  title={f({
                    id: 'online.panel.map.close',
                  })}
                  onClick={handleCloseBluecoinPanel}
                  data-cy="close-bluecoin-panel"
                >
                  <i className="cmd-icon cmd-icon-remove" />
                  <span className="sr-only">{f({ id: 'online.panel.map.close' })}</span>
                </button>
              </li>
            </ul>
          </div>

          <div className="b-widgets-info-tab-content">
            <div
              style={{
                height: '232px',
                minWidth: '832px',
                minHeight: '224px',
              }}
            >
              <div
                style={{
                  zIndex: '9999',
                  width: '824px',
                  height: '224px',
                  position: 'absolute',
                  transform: 'translate(4px, 4px)',
                }}
              >
                <div data-cy="bluecoin-panel" className="ble-panel">
                  <div className="row">
                    {isBluecoinListPanelOpen && (
                      <button
                        type="button"
                        style={{ color: 'rgb(73, 73, 73)' }}
                        className="back-link"
                      >
                        <i
                          className="cmd-icon cmd-icon-back mr-1"
                          onClick={handleBackToBluecoinList}
                          data-cy="bluecoin-panel-back-icon"
                        />
                        {f({ id: 'bluecoins.bluecoinPanel.backToBluecoinList' })}
                      </button>
                    )}
                    {bluecoinData && (
                      <React.Fragment key={`bluecoin-detail-${isBluecoinSelected}`}>
                        <div className="col-12">
                          <span>{f({ id: 'bluecoin.panel.detail.name' })}:</span>
                          <strong className="ml-2">{bluecoinData.name}</strong>
                        </div>
                        <div className="col-12  my-1">
                          <span>{f({ id: 'alarms.section.vehicles.vehicleId' })}:</span>
                          <strong className="ml-2">{bluecoinData.assignedTo?.name || ''}</strong>
                        </div>
                        <div className="col-12  my-1">
                          <span>{f({ id: 'table_list.columns.bluecoin.usageStart' })}:</span>
                          <strong className="ml-2">
                            {handleDateFormat(bluecoinData.assignedTo?.startTs ?? null)}
                          </strong>
                        </div>
                        <div className="col-12  my-1">
                          <span>{f({ id: 'bluecoin.panel.detail.lastPosition' })}:</span>
                          <strong className="ml-2">
                            {bluecoinData.position.address ||
                              `${bluecoinData.position.latitude}, ${bluecoinData.position.longitude}`}
                          </strong>
                        </div>
                        <div className="col-12  my-1">
                          <span>
                            {f({
                              id: 'bluecoin.panel.detail.lastPosition.date',
                            })}
                            :
                          </span>
                          <strong className="ml-2">
                            {handleDateFormat(bluecoinData.position.timestamp ?? null)}
                          </strong>
                        </div>
                        <div className="col-12  my-1">
                          <span>
                            {f({
                              id: 'bluecoin.panel.detail.battery.state',
                            })}
                            :
                          </span>
                          <strong className="ml-2">
                            {bluecoinData.attributes?.bat && `${bluecoinData.attributes.bat} mV`}
                          </strong>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
                <span className="react-resizable-handle react-resizable-handle-se" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
